import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export function useGoogleSheetsAccount() {
  const { data, ...arg } = useQuery<{ account: crmModels.GoogleSheetsAccountType | null }>(
    [crmConstants.queryKeys.GOOGLE_SHEETS_ACCOUNT],
    async () => {
      const { data } = await $api.get('/v1/crm/drive/account');

      return { account: data?.data };
    }
  );

  return { ...data, ...arg };
}
